module.exports = __webpack_public_path__ + "img/retrospect-129.acc87cb3.jpg";